import React from "react";
import styles from "./video_stream.module.scss";
import API from "@unisearch/helpers/api";

export const VideoStream = ({ myInfo, configs, type }) => {
  const conferenceContainerId = "conference-container-id";
  const domain = "unimeet-server-route.myunisearch.com";

  const [jitsi, setJitsi] = React.useState({});

  const loadJitsiScript = () => {
    let resolveLoadJitsiScriptPromise = null;

    const loadJitsiScriptPromise = new Promise((resolve) => {
      resolveLoadJitsiScriptPromise = resolve;
    });

    const script = document.createElement("script");
    script.src = "https://unimeet-server-route.myunisearch.com/external_api.js";
    script.async = true;
    script.onload = () => resolveLoadJitsiScriptPromise(true);
    document.body.appendChild(script);

    return loadJitsiScriptPromise;
  };

  const changeMeetingStatusForCounsiller = async () => {
    if (type === "mentor") {
      if (configs.moderator) {
        try {
          await API.get(`/core/reset-mentor-meeting-status/${configs.room}`)
            .then((res) => {})
            .catch((error) => {
              //console.log(error);
            });
        } catch (error) {
          // console.log(error);
        }
      }
    } else {
      if (configs.moderator) {
        try {
          await API.get(`/core/reset-meeting-status/${configs.room}`)
            .then((res) => {})
            .catch((error) => {
              //console.log(error);
            });
        } catch (error) {
          // console.log(error);
        }
      }
    }
  };

  const initialiseJitsi = async () => {
    if (!window.JitsiMeetExternalAPI) {
      await loadJitsiScript();
    }

    const options = {
      roomName: configs.room,
      roomPassword: configs.room + "-01",
      width: "100%",
      height: 700,
      configOverwrite: {
        disableDeepLinking: true,
        prejoinPageEnabled: false,
        disableThirdPartyRequests: false,
      },
      interfaceConfigOverwrite: {
        filmStripOnly: false,
      },

      parentNode: document.getElementById(conferenceContainerId),
      userInfo: {
        moderator: configs.moderator,
        displayName: myInfo.name,
        email: myInfo.email,
      },
      moderator: configs.moderator, //:false //configs.moderator
    };

    const _jitsi = new window.JitsiMeetExternalAPI(domain, options);
    // _jitsi.executeCommand('subject', 'Instant Video Session');

    _jitsi.addEventListener("participantRoleChanged", function(event) {
      if (event.role === "moderator" && configs.moderator === true) {
        _jitsi.executeCommand("password", options.roomPassword);
      }
    });

    _jitsi.addEventListener("passwordRequired", () => {
      _jitsi.executeCommand("password", options.roomPassword);
    });

    _jitsi.addEventListener("readyToClose", function() {
      // console.log('call hung up fron add Event Listener Event');
      changeMeetingStatusForCounsiller();
    });
    setJitsi(_jitsi);
  };

  React.useEffect(() => {
    initialiseJitsi();

    window.addEventListener("beforeunload", function(e) {
      let confirmationMessage = "o/";
      //(e || window.event).returnValue = confirmationMessage; //Gecko + IE
      changeMeetingStatusForCounsiller();

      //return confirmationMessage; //Webkit, Safari, Chrome
    });

    return () => jitsi?.dispose?.();
  }, []);

  return (
    <div id={conferenceContainerId} style={{ height: 720, width: "100%" }} />
  );
};

export default VideoStream;
